import { pageEntity } from './pageEntity';
import { Dispatchable, dispatchable } from 'module/Redux';
import { MelezeApi } from 'module/Service/MelezeApi';
import { PageKey } from './index';
import { LoggerUtils } from 'module/Common';

export namespace PageAction {
  export const fetchPage = (key: PageKey): Dispatchable => {
    try {
      const prefetched = MelezeApi.getPrefetchedPage(key);
      if (prefetched !== null) {
        return pageEntity.actionCreators.byKeyAction(res => ({ key, resourceAction: res.resolved(prefetched) }));
      }
    } catch (error) {
      LoggerUtils.logError(error);
      // return pageEntity.actionCreators.byKeyAction(res => ({ key, resourceAction: res.rejected(error) }));
    }
    return dispatchable([
      pageEntity.actionCreators.byKeyAction(res => ({ key, resourceAction: res.pending(null) })),
      MelezeApi.getPage(key)
        .then(page => pageEntity.actionCreators.byKeyAction(res => ({ key, resourceAction: res.resolved(page) })))
        .catch(e => pageEntity.actionCreators.byKeyAction(res => ({ key, resourceAction: res.rejected(e) }))),
    ]);
  };
}



// WEBPACK FOOTER //
// ./src/module/Redux/Page/PageAction.ts